import { applyTraitChanges } from "utils/traitsUtils";

const useApplyTraitChanges = (
  originalTraits: number[],
  newTraits: number[]
): number[] => applyTraitChanges(originalTraits, newTraits);

export default useApplyTraitChanges;
